
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

import { use } from './lib/extension';
export * from './lib/export/core';
import { SVGRenderer, CanvasRenderer } from './lib/export/renderers';
import { LineChart, BarChart, PieChart, ScatterChart, RadarChart, MapChart, TreeChart, TreemapChart, GraphChart, GaugeChart, FunnelChart, ParallelChart, SankeyChart, BoxplotChart, CandlestickChart, EffectScatterChart, LinesChart, HeatmapChart, PictorialBarChart, ThemeRiverChart, SunburstChart, CustomChart } from './lib/export/charts';
import { GridComponent, PolarComponent, GeoComponent, SingleAxisComponent, ParallelComponent, CalendarComponent, GraphicComponent, ToolboxComponent, TooltipComponent, AxisPointerComponent, BrushComponent, TitleComponent, TimelineComponent, MarkPointComponent, MarkLineComponent, MarkAreaComponent, LegendComponent, DataZoomComponent, DataZoomInsideComponent, DataZoomSliderComponent, VisualMapComponent, VisualMapContinuousComponent, VisualMapPiecewiseComponent, AriaComponent, DatasetComponent, TransformComponent } from './lib/export/components';
use([CanvasRenderer]);
use([SVGRenderer]);
use([LineChart, BarChart, PieChart, ScatterChart, RadarChart, MapChart, TreeChart, TreemapChart, GraphChart, GaugeChart, FunnelChart, ParallelChart, SankeyChart, BoxplotChart, CandlestickChart, EffectScatterChart, LinesChart, HeatmapChart, PictorialBarChart, ThemeRiverChart, SunburstChart, CustomChart]);
use(GridComponent);
use(PolarComponent);
use(GeoComponent);
use(SingleAxisComponent);
use(ParallelComponent);
use(CalendarComponent);
use(GraphicComponent);
use(ToolboxComponent);
use(TooltipComponent);
use(AxisPointerComponent);
use(BrushComponent);
use(TitleComponent);
use(TimelineComponent);
use(MarkPointComponent);
use(MarkLineComponent);
use(MarkAreaComponent);
use(LegendComponent);
use(DataZoomComponent);
use(DataZoomInsideComponent);
use(DataZoomSliderComponent);
use(VisualMapComponent);
use(VisualMapContinuousComponent);
use(VisualMapPiecewiseComponent);
use(AriaComponent);
use(TransformComponent);
use(DatasetComponent);